import { defineStore } from 'pinia'
import { computed, ref, toRefs } from 'vue'

const usePrivateStore = defineStore('navbar-private', () => {
  const ids = ref<Record<string, string>>({})
  return { ids }
})

export const useNavbarStore = defineStore('navbar', () => {
  const { ids } = toRefs(usePrivateStore())

  const set = (id: string, name: string) => {
    ids.value[id] = name
  }

  return { setNavbarId: set, nameOfId: computed(() => ids.value) }
})
